export default {
    title: 'Erhebungszeitraum erstellen',
    createStatisticSurveyPeriod: 'Erhebungszeitraum erstellen',
    createAndEditStatisticSurveyPeriod: 'Erstellen und weiter bearbeiten',
    createStatisticSurveyPeriodSuccess: 'Der Erhebungszeitraum wurde erfolgreich erstellt.',
    createStatisticSurveyPeriodError: 'Der Erhebungszeitraum konnte nicht erstellt werden.'
}